export default "__VITE_ASSET__CFCRqjuK__"